export default "__VITE_ASSET__EOJmKBwd__"